/*
 * PSC Halloween costume (Oct 2026). Loaded deferred, only while the costume is on.
 * 1. strips the costume in the browser once the sale has ended (cached pages, open tabs)
 * 2. tap to copy the discount code, with a short "Nukopijuota" confirmation
 * 3. countdowns to the real sale end (the screen reader label follows, minute by minute)
 * 4. pauses the banner bats while they are off screen
 * 5. product page "Helovino staigmena": email in, foil turns scratchable, code out
 *
 * The email goes to Shopify as a newsletter signup (the same POST /contact form_type=customer the
 * footer form makes, tags newsletter + halloween-2026). It is a normal form submit through Shopify's
 * own hCaptcha (invisible unless Shopify doubts the visitor), then Shopify brings the shopper back
 * to this page (?psc_hw=1 or ?customer_posted=true) with the foil ready to scratch.
 * State lives in localStorage 'psc-hw-2026': {s:'p'} signup pending, {s:1} email in, {s:2} revealed.
 * The head snippet reads it before the first paint and puts psc-hw-st-scratch / psc-hw-st-open on
 * <html>; the CSS shows the matching state from that class.
 * No third party scripts, no libraries.
 */
(function () {
  'use strict';

  var script = document.currentScript;
  var data = (script && script.dataset) || {};
  var END = Number(data.end) * 1000;
  var root = document.documentElement;
  var KEY = 'psc-hw-2026';
  var motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function calm() {
    return !!(motionQuery && motionQuery.matches);
  }

  function teardown() {
    document.querySelectorAll('[data-psc-hw]').forEach(function (el) {
      el.remove();
    });
    root.classList.remove('psc-hw-st-scratch', 'psc-hw-st-open');
    var css = document.getElementById('psc-hw-css');
    if (css) css.disabled = true;
    var vars = document.getElementById('psc-hw-vars');
    if (vars) vars.remove();
  }

  if (END && Date.now() > END) {
    teardown();
    return;
  }

  /* ---------- copy the code ---------- */
  function fallbackCopy(text) {
    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
    document.body.appendChild(area);
    area.select();
    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (e) {}
    area.remove();
    return ok;
  }

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(
        function () {
          return true;
        },
        function () {
          return fallbackCopy(text);
        }
      );
    }
    return Promise.resolve(fallbackCopy(text));
  }

  /* ---------- countdowns ---------- */
  var countdowns = document.querySelectorAll('[data-psc-hw-countdown]');

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function tick() {
    var now = Date.now();
    if (now > END) {
      teardown();
      return false;
    }
    countdowns.forEach(function (cd) {
      var end = Number(cd.getAttribute('data-end')) * 1000 || END;
      var left = Math.max(0, end - now);
      var parts = {
        d: Math.floor(left / 86400000),
        h: pad(Math.floor(left / 3600000) % 24),
        m: pad(Math.floor(left / 60000) % 60),
        s: pad(Math.floor(left / 1000) % 60)
      };
      Object.keys(parts).forEach(function (key) {
        var el = cd.querySelector('[data-psc-hw-' + key + ']');
        if (el && el.textContent !== String(parts[key])) el.textContent = parts[key];
      });
      var label = [
        cd.getAttribute('data-label'),
        parts.d, cd.getAttribute('data-u-d'),
        parts.h, cd.getAttribute('data-u-h'),
        parts.m, cd.getAttribute('data-u-m')
      ].join(' ');
      if (cd.getAttribute('aria-label') !== label) cd.setAttribute('aria-label', label);
    });
    return true;
  }

  /* one timer for everything; it also ends the costume at the exact end second */
  if (tick()) {
    var timer = setInterval(function () {
      if (document.hidden) return;
      if (!tick()) clearInterval(timer);
    }, countdowns.length ? 1000 : 30000);
  }

  /* ---------- animations (banner bats): pause while off screen ---------- */
  var anims = document.querySelectorAll('[data-psc-hw-anim]');
  if (anims.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-paused', !entry.isIntersecting);
      });
    });
    anims.forEach(function (el) {
      el.classList.add('is-paused');
      io.observe(el);
    });
  }

  /* ======================================================================
     HELOVINO STAIGMENA (product page)
     ====================================================================== */

  /* ---------- state ---------- */
  var memory = {};

  function readState() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (v && typeof v === 'object') return v;
    } catch (e) {}
    return memory;
  }

  function saveState(v) {
    v.t = Date.now();
    memory = v;
    try {
      localStorage.setItem(KEY, JSON.stringify(v));
    } catch (e) {}
  }

  function storageWorks() {
    try {
      localStorage.setItem(KEY + '-t', '1');
      localStorage.removeItem(KEY + '-t');
      return true;
    } catch (e) {
      return false;
    }
  }

  function level() {
    var s = readState().s;
    return s === 2 ? 2 : s === 1 ? 1 : 0;
  }

  function paint() {
    var l = level();
    root.classList.toggle('psc-hw-st-scratch', l === 1);
    root.classList.toggle('psc-hw-st-open', l === 2);
    gifts().forEach(function (gift) {
      if (l === 1) foil(gift);
      else if (l === 2 && gift.pscHw && !gift.pscHw.leaving) gift.pscHw.drop();
    });
  }

  function gifts() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-psc-hw-gift]'));
  }

  function say(gift, text) {
    var live = gift && gift.querySelector('[data-psc-hw-live]');
    if (!live || !text) return;
    live.textContent = '';
    setTimeout(function () {
      live.textContent = text;
    }, 60);
  }

  function buzz(ms) {
    try {
      if (navigator.vibrate) navigator.vibrate(ms);
    } catch (e) {}
  }

  /* ---------- images (foil art + the little burst) ---------- */
  var images = {};

  function image(src) {
    if (!src) return null;
    if (!images[src]) {
      var img = new Image();
      img.decoding = 'async';
      img.src = src;
      images[src] = img;
    }
    return images[src];
  }

  function ready(img) {
    return !!(img && img.complete && img.naturalWidth);
  }

  /* ---------- the scratch foil ----------
     A canvas over the ticket. Scratching cuts round strokes out of it (destination-out).
     Progress is counted on a 24 x 8 grid of the strokes themselves (no pixel reads, so it is
     cheap and never trips over image security rules). At 45% the rest falls away by itself. */
  var COLS = 24;
  var ROWS = 8;
  var DONE_AT = 0.45;

  function foil(gift) {
    if (gift.pscHw) return gift.pscHw;
    var ticket = gift.querySelector('.psc-hw-ticket');
    if (!ticket || !ticket.offsetWidth) return null;
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext && canvas.getContext('2d');
    if (!ctx) return null;
    canvas.className = 'psc-hw-ticket__canvas';
    canvas.setAttribute('aria-hidden', 'true');
    ticket.appendChild(canvas);

    var label = (gift.getAttribute('data-scratch') || '').toLocaleUpperCase();
    var art = image(data.art);
    [data.bat, data.pumpkin, data.ghost].forEach(image);

    var W = 0;
    var H = 0;
    var brush = 32;
    var strokes = [];
    var cells = new Uint8Array(COLS * ROWS);
    var cleared = 0;
    var last = null;
    var travel = 0;
    var finished = false;
    var observer = null;

    function paintFoil() {
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
      ctx.clearRect(0, 0, W, H);

      var g = ctx.createLinearGradient(0, 0, W, H);
      g.addColorStop(0, '#f4a04c');
      g.addColorStop(0.42, '#e8701a');
      g.addColorStop(1, '#c4520e');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, W, H);

      /* engraved hatching, same as the CSS foil */
      ctx.strokeStyle = 'rgba(70, 25, 0, 0.12)';
      ctx.lineWidth = 1;
      ctx.beginPath();
      for (var x = -H; x < W; x += 4) {
        ctx.moveTo(x, H);
        ctx.lineTo(x + H, 0);
      }
      ctx.stroke();

      /* the cute pumpkins pressed into the foil: multiply keeps only the ink lines */
      if (ready(art)) {
        var ah = H * 1.1;
        var aw = (ah * art.naturalWidth) / art.naturalHeight;
        ctx.save();
        ctx.globalAlpha = 0.62;
        ctx.globalCompositeOperation = 'multiply';
        ctx.drawImage(art, W - aw * 0.94, H - ah * 0.93, aw, ah);
        ctx.restore();
      }

      /* foil sheen */
      var s = ctx.createLinearGradient(0, 0, W, H * 0.7);
      s.addColorStop(0.18, 'rgba(255,255,255,0)');
      s.addColorStop(0.36, 'rgba(255,238,214,0.45)');
      s.addColorStop(0.5, 'rgba(255,255,255,0)');
      ctx.fillStyle = s;
      ctx.fillRect(0, 0, W, H);

      /* glints */
      ctx.fillStyle = 'rgba(255,248,236,0.9)';
      [[0.07, 0.24, 3.5], [0.43, 0.2, 2.5], [0.55, 0.8, 3], [0.29, 0.8, 2]].forEach(function (p) {
        var gx = p[0] * W;
        var gy = p[1] * H;
        var r = p[2];
        ctx.beginPath();
        ctx.moveTo(gx, gy - r * 2);
        ctx.quadraticCurveTo(gx, gy, gx + r * 2, gy);
        ctx.quadraticCurveTo(gx, gy, gx, gy + r * 2);
        ctx.quadraticCurveTo(gx, gy, gx - r * 2, gy);
        ctx.quadraticCurveTo(gx, gy, gx, gy - r * 2);
        ctx.fill();
      });

      /* perforated edge */
      ctx.strokeStyle = 'rgba(17,17,17,0.38)';
      ctx.lineWidth = 1;
      if (ctx.setLineDash) ctx.setLineDash([4, 4]);
      ctx.strokeRect(7.5, 7.5, W - 15, H - 15);
      if (ctx.setLineDash) ctx.setLineDash([]);

      /* coin + NUTRINK ČIA */
      var fs = Math.round(Math.max(14, Math.min(18, H * 0.19)));
      var cx = 22 + fs * 0.75;
      var cy = H / 2;
      var cr = fs * 0.78;
      ctx.fillStyle = '#111';
      ctx.beginPath();
      ctx.arc(cx, cy, cr, 0, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = '#f4a04c';
      ctx.lineWidth = 1.6;
      ctx.lineCap = 'round';
      ctx.beginPath();
      for (var i = -1; i <= 1; i++) {
        var o = i * cr * 0.38;
        ctx.moveTo(cx - cr * 0.42 + o, cy + cr * 0.42 + o * 0.2);
        ctx.lineTo(cx + cr * 0.2 + o, cy - cr * 0.3 + o * 0.2);
      }
      ctx.stroke();

      ctx.fillStyle = '#111';
      ctx.font = '800 ' + fs + 'px Archivo, "Helvetica Neue", Arial, sans-serif';
      ctx.textBaseline = 'middle';
      if ('letterSpacing' in ctx) ctx.letterSpacing = '0.1em';
      ctx.fillText(label, cx + cr + 10, cy + 1);
      if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';
    }

    function cut(a, b) {
      var ax = a[0] * W;
      var ay = a[1] * H;
      var bx = b[0] * W;
      var by = b[1] * H;
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.lineWidth = brush;
      ctx.beginPath();
      ctx.moveTo(ax, ay);
      ctx.lineTo(bx + 0.01, by);
      ctx.stroke();
      ctx.globalCompositeOperation = 'source-over';

      var r = brush / 2;
      var cw = W / COLS;
      var ch = H / ROWS;
      var dist = Math.sqrt((bx - ax) * (bx - ax) + (by - ay) * (by - ay));
      var steps = Math.max(1, Math.ceil(dist / (brush / 3)));
      for (var i = 0; i <= steps; i++) {
        var x = ax + ((bx - ax) * i) / steps;
        var y = ay + ((by - ay) * i) / steps;
        var c0 = Math.max(0, Math.floor((x - r) / cw));
        var c1 = Math.min(COLS - 1, Math.floor((x + r) / cw));
        var r0 = Math.max(0, Math.floor((y - r) / ch));
        var r1 = Math.min(ROWS - 1, Math.floor((y + r) / ch));
        for (var row = r0; row <= r1; row++) {
          for (var col = c0; col <= c1; col++) {
            var k = row * COLS + col;
            if (cells[k]) continue;
            var px = (col + 0.5) * cw - x;
            var py = (row + 0.5) * ch - y;
            if (px * px + py * py <= r * r) {
              cells[k] = 1;
              cleared++;
            }
          }
        }
      }
    }

    function layout() {
      var rect = ticket.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = rect.width;
      H = rect.height;
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      brush = Math.max(26, Math.min(44, H * 0.36));
      cells = new Uint8Array(COLS * ROWS);
      cleared = 0;
      paintFoil();
      strokes.forEach(function (stroke) {
        for (var i = 0; i < stroke.length; i++) cut(stroke[i - 1] || stroke[i], stroke[i]);
      });
      ticket.classList.add('has-canvas');
    }

    function point(e) {
      var rect = canvas.getBoundingClientRect();
      return [(e.clientX - rect.left) / rect.width, (e.clientY - rect.top) / rect.height];
    }

    function check() {
      if (!finished && cleared / (COLS * ROWS) >= DONE_AT) reveal(gift, true);
    }

    canvas.addEventListener('pointerdown', function (e) {
      if (finished || (e.pointerType === 'mouse' && e.button !== 0)) return;
      e.preventDefault();
      try {
        canvas.setPointerCapture(e.pointerId);
      } catch (err) {}
      last = point(e);
      strokes.push([last]);
      cut(last, last);
      gift.classList.add('is-scratching');
      buzz(6);
    });

    canvas.addEventListener('pointermove', function (e) {
      if (!last || finished) return;
      var list = (e.getCoalescedEvents && e.getCoalescedEvents()) || [];
      if (!list.length) list = [e];
      for (var i = 0; i < list.length; i++) {
        var p = point(list[i]);
        travel += Math.abs(p[0] - last[0]) * W + Math.abs(p[1] - last[1]) * H;
        cut(last, p);
        strokes[strokes.length - 1].push(p);
        last = p;
      }
      if (travel > 70) {
        travel = 0;
        buzz(3);
      }
      check();
    });

    function lift() {
      last = null;
      gift.classList.remove('is-scratching');
      check();
    }

    canvas.addEventListener('pointerup', lift);
    canvas.addEventListener('pointercancel', lift);
    canvas.addEventListener('lostpointercapture', lift);

    layout();
    if (art && !ready(art)) art.addEventListener('load', layout, { once: true });
    if (document.fonts && document.fonts.load) {
      document.fonts.load('800 16px Archivo').then(layout, function () {});
    }
    if ('ResizeObserver' in window) {
      var lastW = W;
      observer = new ResizeObserver(function () {
        var w = ticket.getBoundingClientRect().width;
        if (!finished && Math.abs(w - lastW) > 1) {
          lastW = w;
          layout();
          check();
        }
      });
      observer.observe(ticket);
    }

    var api = {
      leaving: false,
      /* the foil falls away: fade, then gone */
      finish: function () {
        finished = true;
        api.leaving = true;
        if (observer) observer.disconnect();
        canvas.classList.add('is-leaving');
        requestAnimationFrame(function () {
          canvas.classList.add('is-gone');
        });
        setTimeout(api.drop, calm() ? 0 : 650);
      },
      drop: function () {
        finished = true;
        if (observer) observer.disconnect();
        canvas.remove();
        ticket.classList.remove('has-canvas');
        gift.pscHw = null;
      }
    };
    gift.pscHw = api;
    return api;
  }

  /* ---------- reveal: bats and pumpkins fly out, the code pops ---------- */
  function burst(gift) {
    var ticket = gift.querySelector('.psc-hw-ticket');
    if (!ticket || calm() || !Element.prototype.animate) return;
    var g = gift.getBoundingClientRect();
    var t = ticket.getBoundingClientRect();
    var layer = document.createElement('div');
    layer.className = 'psc-hw-burst';
    layer.setAttribute('aria-hidden', 'true');
    layer.style.left = t.left - g.left + t.width / 2 + 'px';
    layer.style.top = t.top - g.top + t.height / 2 + 'px';
    gift.appendChild(layer);

    var kinds = ['bat', 'pumpkin', 'bat', 'ghost', 'bat', 'pumpkin', 'bat', 'bat', 'ghost', 'bat', 'pumpkin', 'bat'];
    var reach = Math.min(170, Math.max(110, t.width * 0.45));
    kinds.forEach(function (kind, i) {
      var src = data[kind];
      if (!src) return;
      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.className = 'psc-hw-burst__' + kind;
      layer.appendChild(img);
      /* fan out over the upper half, a little gravity at the end */
      var angle = ((-172 + (164 * i) / (kinds.length - 1) + (Math.random() * 14 - 7)) * Math.PI) / 180;
      var dist = reach * (0.55 + Math.random() * 0.45);
      var dx = Math.cos(angle) * dist;
      var dy = Math.sin(angle) * dist * 0.7;
      var spin = Math.random() * 50 - 25;
      img.animate(
        [
          { transform: 'translate(-50%, -50%) scale(0.3)', opacity: 0 },
          {
            transform: 'translate(calc(-50% + ' + dx * 0.6 + 'px), calc(-50% + ' + dy * 0.7 + 'px)) scale(1) rotate(' + spin / 2 + 'deg)',
            opacity: 1,
            offset: 0.35
          },
          {
            transform: 'translate(calc(-50% + ' + dx + 'px), calc(-50% + ' + (dy + 26) + 'px)) scale(0.8) rotate(' + spin + 'deg)',
            opacity: 0
          }
        ],
        { duration: 1100 + Math.random() * 450, delay: i * 22, easing: 'cubic-bezier(.16,.72,.3,1)', fill: 'both' }
      );
    });
    setTimeout(function () {
      layer.remove();
    }, 2000);
  }

  function reveal(gift, fancy) {
    saveState({ s: 2 });
    var api = gift && gift.pscHw;
    if (api && !api.leaving) api.finish();
    paint();
    if (!gift) return;
    if (fancy) burst(gift);
    gift.classList.remove('is-revealed');
    void gift.offsetWidth;
    gift.classList.add('is-revealed');
    buzz(18);
    say(gift, gift.getAttribute('data-revealed'));
    var btn = gift.querySelector('.psc-hw-gift__copy');
    if (btn) {
      setTimeout(function () {
        try {
          btn.focus({ preventScroll: true });
        } catch (e) {
          btn.focus();
        }
      }, 80);
    }
  }

  /* ---------- the email ---------- */
  var EMAIL = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[^\s@.]{2,}$/;

  function setError(form, msg) {
    var err = form.querySelector('[data-psc-hw-err]');
    var input = form.querySelector('input[type="email"]');
    if (err) err.textContent = msg || '';
    if (input) {
      if (msg) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }
    form.classList.toggle('has-error', !!msg);
  }

  function busy(form, on) {
    form.classList.toggle('is-busy', on);
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  /* Shopify sends the shopper here after its captcha page */
  function returnUrl() {
    var search = location.search
      .replace(/([?&])(psc_hw|customer_posted|form_type|form_key)=[^&]*/g, '$1')
      .replace(/[?&]+$/, '')
      .replace(/\?&+/, '?')
      .replace(/&&+/g, '&');
    return location.pathname + search + (search ? '&' : '?') + 'psc_hw=1';
  }

  /* Oct 8 fix: Shopify requires its hCaptcha token on customer forms ("Missing CAPTCHA token").
     So the form is a normal Shopify form again and Shopify's own captcha script submits it:
     we only validate, remember that a signup is pending, and let the submit event through.
     Shopify then brings the shopper back here (?psc_hw=1 or ?customer_posted=true) ready to scratch. */
  function send(form, event) {
    var input = form.querySelector('input[type="email"]');
    var err = form.querySelector('[data-psc-hw-err]');
    if (!input || form.classList.contains('is-busy')) {
      event.preventDefault();
      return;
    }
    var email = (input.value || '').trim();
    input.value = email;
    if (!EMAIL.test(email) || email.length > 254) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setError(form, err && err.getAttribute('data-email'));
      input.focus();
      return;
    }
    setError(form, '');
    var back = form.querySelector('[data-psc-hw-return]');
    if (back) back.value = returnUrl();

    /* captcha not bound yet (e.g. autofill without focus): bind it, then submit again */
    if (!form.dataset.hcaptchaBound && !form.dataset.recaptchaBound) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.pscHwWait) return;
      form.dataset.pscHwWait = '1';
      busy(form, true);
      try {
        input.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
      } catch (e) {}
      var tries = 0;
      (function wait() {
        tries += 1;
        if (form.dataset.hcaptchaBound || form.dataset.recaptchaBound || tries > 40) {
          delete form.dataset.pscHwWait;
          busy(form, false);
          if (form.requestSubmit) form.requestSubmit();
          else HTMLFormElement.prototype.submit.call(form);
          return;
        }
        setTimeout(wait, 150);
      })();
      return;
    }

    saveState({ s: 'p' });
    busy(form, true);
    /* safety: if the page has not navigated after 20 s, let the shopper try again */
    setTimeout(function () {
      busy(form, false);
    }, 20000);
  }

  /* ---------- back from Shopify's captcha page ---------- */
  function cameBack() {
    var q = location.search;
    if (!/[?&](psc_hw=1|customer_posted=true|form_type=customer)/.test(q)) return false;
    var pending = readState().s === 'p' || (!storageWorks() && /[?&]psc_hw=1/.test(q));
    if (!pending) return false;
    saveState({ s: 1 });
    try {
      var url = new URL(location.href);
      ['psc_hw', 'customer_posted', 'form_type', 'form_key'].forEach(function (k) {
        url.searchParams.delete(k);
      });
      var hash = /^#(contact_form|psc-hw)?$/.test(url.hash) ? '' : url.hash;
      history.replaceState(history.state, '', url.pathname + url.search + hash);
    } catch (e) {}
    return true;
  }

  /* ---------- events (delegated, so re-rendered markup keeps working) ---------- */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var copyBtn = target.closest('[data-psc-hw-copy]');
    if (copyBtn) {
      event.preventDefault();
      var host = copyBtn.closest('[data-psc-hw-copy-host]') || copyBtn.parentElement;
      var done = host && host.querySelector('[data-psc-hw-done]');
      copy(copyBtn.getAttribute('data-psc-hw-copy')).then(function (ok) {
        if (!ok || !done) return;
        done.textContent = done.getAttribute('data-ok');
        host.classList.add('is-copied');
        clearTimeout(host.pscHwTimer);
        host.pscHwTimer = setTimeout(function () {
          done.textContent = '';
          host.classList.remove('is-copied');
        }, 2200);
      });
      return;
    }

    var now = target.closest('[data-psc-hw-reveal]');
    if (now) {
      event.preventDefault();
      reveal(now.closest('[data-psc-hw-gift]'), true);
    }
  });

  /* capture phase: runs before Shopify's own form listener, the form never leaves the page */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('[data-psc-hw-form]')) return;
      send(form, event);
    },
    true
  );

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input || !input.closest) return;
    var form = input.closest('[data-psc-hw-form]');
    if (form && form.classList.contains('has-error')) setError(form, '');
  });

  /* back button from Shopify's captcha page restores this page from memory: un-stick the button */
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('[data-psc-hw-form].is-busy').forEach(function (form) {
      busy(form, false);
    });
    paint();
  });

  /* another tab revealed it */
  window.addEventListener('storage', function (event) {
    if (event.key === KEY) paint();
  });

  /* ---------- start ---------- */
  var returned = cameBack();
  paint();
  if (returned) {
    var gift = gifts()[0];
    if (gift) {
      gift.classList.add('is-fresh');
      setTimeout(function () {
        gift.scrollIntoView({ block: 'center', behavior: calm() ? 'auto' : 'smooth' });
        say(gift, gift.getAttribute('data-thanks'));
      }, 300);
    }
  }
})();
